import { httpClient } from 'shared/lib'
import { AxiosError, isAxiosError } from 'axios'
import consoleMessage from 'shared/utils/helpers/consoleMessage'
import { CustomerType } from './types'

export function fetchCustomers() {
   let errMessage = ''
   return httpClient
      .get<CustomerType[]>('clients')
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage =
               `status: ${error.response?.status},url: ${error.response?.config.url}, message:${error.response?.data?.errors[0].defaultMessage}` ||
               'Unexpected error'
         } else {
            errMessage = error.message
         }
         consoleMessage('Customers fetchCustomers service', errMessage, 'error')
         throw new Error(errMessage)
      })
}

export function createCustomer(payload: CustomerType) {
   let errMessage

   return httpClient
      .post<{ data: CustomerType; status: number }>(`/clients`, payload)
      .then((res) => ({
         data: res.data,
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMER createCustomer service', errMessage, 'error')
         throw error
      })
}

export function editCustomer(customerUuid: string, payload: CustomerType) {
   let errMessage

   return httpClient
      .put(`/clients/${customerUuid}`, payload)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMER editCustomer service', errMessage, 'error')
         throw error
      })
}

export function deleteCustomer(customerUuid: string, force?: boolean) {
   let errMessage
   const url = force ? `/clients/${customerUuid}?force=true` : `/clients/${customerUuid}`

   return httpClient
      .delete(url)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMER deleteCustomer', errMessage, 'error')

         throw error
      })
}
